module.exports = __webpack_public_path__ + "static/media/p8_data.461baf52.txt";